import { UiUserProfile } from '@origin8-web/models/core-business';

export const userStoreKey = 'user';
export const interactionTranscriptStateKey = 'interactionTranscript';

export const INTERACTION_TRANSCRIPT_PAGE_PATH = 'interaction';

export type UserState = {
  userInfo: UiUserProfile | undefined | null;
};

export const ORGANIZATION_ROUTE_PARAM = 'organization';
export const ORGANIZATION_ROUTE_PARAM_PATH = '/:' + ORGANIZATION_ROUTE_PARAM;

/** Where the app sends an authenticated user it cannot show anything to. Deliberately org-free. */
export const UNAUTHORIZED_PATH = 'unauthorized';
export const UNAUTHORIZED_FULL_PATH = '/' + UNAUTHORIZED_PATH;

export enum INTERACTION_TRANSCRIPT_ROUTE {
  BASE = INTERACTION_TRANSCRIPT_PAGE_PATH + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/' + INTERACTION_TRANSCRIPT_PAGE_PATH + ORGANIZATION_ROUTE_PARAM_PATH,
  DETAILS = INTERACTION_TRANSCRIPT_PAGE_PATH + ORGANIZATION_ROUTE_PARAM_PATH + '/:id',
  DETAILS_FULL_PATH = '/' + INTERACTION_TRANSCRIPT_PAGE_PATH + ORGANIZATION_ROUTE_PARAM_PATH + '/:id',
}

export enum RULES_ROUTE {
  BASE = 'rules' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/rules' + ORGANIZATION_ROUTE_PARAM_PATH,
  ADD = 'rules/:organization/add',
  ADD_FULL_PATH = '/rules' + ORGANIZATION_ROUTE_PARAM_PATH + '/add',
  EDIT = 'rules' + ORGANIZATION_ROUTE_PARAM_PATH + '/edit/:id',
  EDIT_FULL_PATH = '/rules' + ORGANIZATION_ROUTE_PARAM_PATH + '/edit/:id',
}

export enum RULES_EXPLORER_ROUTE {
  BASE = 'rules-explorer' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/rules-explorer' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export enum SUPERVISORS_ROUTE {
  BASE = 'supervisors' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/supervisors' + ORGANIZATION_ROUTE_PARAM_PATH,
  ADD = 'supervisors/:organization/add',
  ADD_FULL_PATH = '/supervisors' + ORGANIZATION_ROUTE_PARAM_PATH + '/add',
  EDIT = 'supervisors' + ORGANIZATION_ROUTE_PARAM_PATH + '/edit/:id',
  EDIT_FULL_PATH = '/supervisors' + ORGANIZATION_ROUTE_PARAM_PATH + '/edit/:id',
}

export enum SUPERVISOR_VIEW_ROUTE {
  BASE = 'supervisor' + ORGANIZATION_ROUTE_PARAM_PATH + '/:supervisorId',
  BASE_FULL_PATH = '/supervisor' + ORGANIZATION_ROUTE_PARAM_PATH + '/:supervisorId',
  TRENDS = 'trends',
  ACTIVITY = 'activity',
  COMPLIANCE = 'compliance',
  RISK = 'risk',
  INTERACTIONS = 'interactions',
}

export enum ACTIVITY_OVERVIEW_ROUTE {
  BASE = 'activity-overview' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/activity-overview' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export enum DASHBOARD_ROUTE {
  BASE = 'dashboard' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/dashboard' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export enum COMPLIANCE_TRACKING_ROUTE {
  BASE = 'compliance-tracking' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/compliance-tracking' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export enum LEAD_LIFECYCLE_ROUTE {
  BASE = 'lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH,
  CONFIGURATION = 'lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH + '/configuration',
  CONFIGURATION_FULL_PATH = '/lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH + '/configuration',
  CONFIGURATION_CREATE = 'lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH + '/configuration/create',
  CONFIGURATION_CREATE_FULL_PATH = '/lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH + '/configuration/create',
  CONFIGURATION_EDIT = 'lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH + '/configuration/edit/:id',
  CONFIGURATION_EDIT_FULL_PATH = '/lead-lifecycle' + ORGANIZATION_ROUTE_PARAM_PATH + '/configuration/edit/:id',
}

export enum INTERACTIONS_HISTORY_ROUTE {
  BASE = 'interactions-history' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/interactions-history' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export enum LEADS_LIBRARY_ROUTE {
  BASE = 'leads' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/leads' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export enum INTEGRATIONS_ROUTE {
  BASE = 'integrations' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/integrations' + ORGANIZATION_ROUTE_PARAM_PATH,
  ADD = 'integrations' + ORGANIZATION_ROUTE_PARAM_PATH + '/create',
  ADD_FULL_PATH = '/integrations' + ORGANIZATION_ROUTE_PARAM_PATH + '/create',
  EDIT = 'integrations' + ORGANIZATION_ROUTE_PARAM_PATH + '/edit/:integrationId',
  EDIT_FULL_PATH = '/integrations' + ORGANIZATION_ROUTE_PARAM_PATH + '/edit/:integrationId',
}

export enum PHONE_NUMBERS_ROUTE {
  BASE = 'phone-numbers' + ORGANIZATION_ROUTE_PARAM_PATH,
  BASE_FULL_PATH = '/phone-numbers' + ORGANIZATION_ROUTE_PARAM_PATH,
}

export const UNKNOWN_SPEAKER_NAME = 'Unknown speaker';

export interface CallsToReviewQueryFilters {
  startDate: Date;
  endDate: Date;
  minDuration: number;
  maxDuration: number;
}

export const APP_ROUTE_TITLE = {
  HOME_DASHBOARDS: 'Home Dashboards',
  COMPLIANCE_TRACKING: 'Compliance',
  LEAD_LIFECYCLE: 'Lead lifecycle',
  LEADS_LIBRARY: 'Leads',
  INTERACTIONS_HISTORY: 'Call History',
  RULES_CONFIGURATION: 'Rules Library',
  RULES_EXPLORER: 'Rules Explorer',
  SUPERVISORS_CONFIGURATION: 'Supervisors',
  INTERACTION_REPORT_DETAILS: 'Interaction Report Details',
  ACTIVITY_OVERVIEW: 'Activity',
  INTEGRATIONS: 'Integrations',
  PHONE_NUMBERS: 'Phone numbers',
};
